import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import CablesDesign from './pages/CablesDesign';
import ConnectorsStock from './pages/ConnectorsStock';
import CableStock from './pages/CableStock';
import './App.css';

function App() {
  const [darkMode, setDarkMode] = useState(false);

  return (
    <Router>
      <div className={`app ${darkMode ? 'dark' : 'light'}`}>
        <Navbar darkMode={darkMode} setDarkMode={setDarkMode} />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/cables-design" element={<CablesDesign />} />
            <Route path="/connectors-stock" element={<ConnectorsStock />} />
            <Route path="/cable-stock" element={<CableStock />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
